import Mock from 'mockjs'
import { param2Obj } from 'src/utils'
import {season, agent_name, class_name, college, campus, course_name, publish_name} from './datas'

const List = []
const count = 100

for (let i = 0; i < count; i++) {
  List.push(Mock.mock({
    id: '@increment',
    name: `${season[Mock.Random.integer(0, season.length-1)]}选书情况`,
    'agent_name|1': agent_name,
    'book_species': '@integer(50, 2000)',
    'book_total': '@integer(20000,1000000)',
    'discount': Mock.Random.float(5, 10).toFixed(2),
    'price_total': Mock.Random.float(1000000, 90000000).toFixed(2),
    'pay_status': '@boolean',
    timestamp: +Mock.Random.date('T')
  }))
}

const sendList = [];
for (let j = 0; j < count; j++) {
  sendList.push(Mock.mock({
    id: '@increment',
    book_name: '@ctitle(10, 30)',
    'book_type|1': ['教材', '讲义'],
    book_total: '@integer(500, 20000)',
    book_price: Mock.Random.float(20, 60).toFixed(2),
    book_discount: Mock.Random.float(7, 10).toFixed(3),
    pay_total: Mock.Random.float(20000,1000000).toFixed(2),
    'classes|1-5': [
      {
        'class_name|1': class_name,
        'college_name|1': college,
        'campus|1': campus,
        'student_total': '@integer(30, 60)'
      }
    ]
  }))
}


const sendForStudent = [];
for (let k = 0; k < count; k++){
  sendForStudent.push(Mock.mock({
    id: '@increment',
    name: '@cname',//姓名
    student_number: '@integer(700000000,900000000)',//学号
    major: '@ctitle(7,14)',//专业
    'classes|1': class_name,//班级
    'books|1-5': [{
      'course_name|1': course_name,//课程
      'book_name': '@ctitle(10, 20)',//教材
      'book_number_one': 1,//册数01
      'book_number': '@int(10, 20)',//册数
      'publish_name|1': publish_name,//出版社
      'book_isbn': '@guid',//ISBN码
      'book_price': '@int(12, 30)',//预收单价
      'book_price_all': '@int(200, 300)',//预收金额
      'book_price_actual': '@int(12, 30)',//定价
      'book_price_aggregate': '@int(12, 30)',//码洋
      'book_discount': '@int(8, 10)',//折扣
      'book_total_price': '@int(200, 400)',//实洋
      'book_totals_price': '@int(200, 400)',//补缴金额
    }],
  }))
}

const sendForClass = [];
for (let z = 0; z < count; z++){
  sendForClass.push(Mock.mock({
    id: '@increment',
    name: '@cname',//姓名
    student_number: '@integer(700000000,900000000)',//学号
    major: '@ctitle(7,14)',//专业
    'classes|1': class_name,//班级
    'books|1-5': [{
      'course_name|1': course_name,//课程
      'book_name': '@ctitle(10, 20)',//教材
      'book_number_one': '@int(1, 2)',//册数1
      'book_number': '@int(10, 20)',//册数
      'publish_name|1': publish_name,//出版社
      'book_isbn': '@guid',//ISBN码
      'book_price': '@int(12, 30)',//预收单价
      'book_price_all': '@int(100, 300)',//预收金额
      'book_price_actual': '@int(12, 30)',//定价
      'book_price_aggregate': '@int(12, 30)',//码洋
      'book_discount': '@int(8, 10)',//折扣
      'book_total_price': '@int(200, 400)',//实洋
      'book_totals_price': '@int(200, 400)',//补缴金额
    }],
  }))
}


export default {
  getList: config => {
    const { importance, type, title, page = 1, limit = 20, sort } = param2Obj(config.url)

    let mockList = List.filter(item => {
      if (importance && item.importance !== +importance) return false
      if (type && item.type !== type) return false
      if (title && item.title.indexOf(title) < 0) return false
      return true
    })

    if (sort === '-id') {
      mockList = mockList.reverse()
    }

    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))

    return {
      total: mockList.length,
      items: pageList
    }
  },
  getPv: () => ({
    pvData: [{ key: 'PC', pv: 1024 }, { key: 'mobile', pv: 1024 }, { key: 'ios', pv: 1024 }, { key: 'android', pv: 1024 }]
  }),
  getArticle: () => ({
    id: 120000000001,
    author: { key: 'mockPan' },
    source_name: '原创作者',
    category_item: [{ key: 'global', name: '全球' }],
    comment_disabled: true,
    content: '<p>我是测试数据我是测试数据</p><p><img class="wscnph" src="https://wpimg.wallstcn.com/4c69009c-0fd4-4153-b112-6cb53d1cf943" data-wscntype="image" data-wscnh="300" data-wscnw="400" data-mce-src="https://wpimg.wallstcn.com/4c69009c-0fd4-4153-b112-6cb53d1cf943"></p>"',
    content_short: '我是测试数据',
    display_time: +new Date(),
    image_uri: 'https://wpimg.wallstcn.com/e4558086-631c-425c-9430-56ffb46e70b3',
    platforms: ['a-platform'],
    source_uri: 'https://github.com/PanJiaChen/vue-element-admin',
    status: 'published',
    tags: [],
    title: 'vue-element-admin'
  }),
  createArticle: () => ({
    data: 'success'
  }),
  updateArticle: () => ({
    data: 'success'
  }),
  getClearingBalanceList(config){
    const { importance, type, title, page = 1, limit = 20, sort } = param2Obj(config.url)

    let mockList = sendList.filter(item => {
      if (importance && item.importance !== +importance) return false
      if (type && item.type !== type) return false
      if (title && item.title.indexOf(title) < 0) return false
      return true
    })

    if (sort === '-id') {
      mockList = mockList.reverse()
    }

    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))

    return {
      total: mockList.length,
      items: pageList
    }
  },
  getClearingBalanceListForStudent(config) {
    const { importance, type, title, page = 1, limit = 20, sort } = param2Obj(config.url)

    let mockList = sendForStudent.filter(item => {
      if (importance && item.importance !== +importance) return false
      if (type && item.type !== type) return false
      if (title && item.title.indexOf(title) < 0) return false
      return true
    })

    if (sort === '-id') {
      mockList = mockList.reverse()
    }

    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))

    return {
      total: mockList.length,
      items: pageList
    }
  },
  getClearingBalanceListForClass(config) {
    const { importance, type, title, page = 1, limit = 20, sort } = param2Obj(config.url)

    let mockList = sendForClass.filter(item => {
      if (importance && item.importance !== +importance) return false
      if (type && item.type !== type) return false
      if (title && item.title.indexOf(title) < 0) return false
      return true
    })

    if (sort === '-id') {
      mockList = mockList.reverse()
    }

    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))

    return {
      total: mockList.length,
      items: pageList
    }
  }
}



// WEBPACK FOOTER //
// ./src/mock/clearingBalance.js